import React from 'react';
import { getCategoryDisplayName } from '../settings/getCategoryDisplayName';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const SocialSkillPage = ({
  t,
  skillCategory,
  setSkillCategory,
  socialSkill,
  setSocialSkill,
  socialSkillsData,
  setManualSocialSkillInput,
  manualInputRef,
  setSidebarContent,
  setCollapsed,
  setManualSocialSkill,
  currentLang,
  categoryTitle,
  getCategoryName = getCategoryDisplayName,
  getSkillName,
  selectionType = 'social-skill',
  onPresetSelect
}) => {
  const langKey = currentLang === 'English' ? 'en' : currentLang === 'French' ? 'fr' : currentLang === 'Traditional Chinese' ? 'zh-TW' : currentLang === 'Simplified Chinese' ? 'zh-CN' : 'en';

  const handleSkillSelect = (skill) => {
    setSocialSkill(skill);
    if (onPresetSelect) onPresetSelect(skill);
    if (setManualSocialSkillInput) {
      setManualSocialSkillInput(
        getSkillName
          ? getSkillName(skill.key, skillCategory, langKey)
          : (skill[langKey] || skill.en)
      );
    }
    if (manualInputRef && manualInputRef.current) manualInputRef.current.focus();
    if (setSidebarContent) setSidebarContent('default');
    if (setCollapsed) setCollapsed(true);
    if (setManualSocialSkill) setManualSocialSkill(false);
    // Also close the sidebar if setDrawerOpen is available (mobile)
    if (typeof window !== 'undefined') {
      if (window.setDrawerOpen) {
        window.setDrawerOpen(false);
      } else if (window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('closeDrawerFromSkillSelect'));
      }
    }
      };
  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {categoryTitle || t["sb_skill_category"] || "Social Skill Category"}
      </Typography>
      <List>
        {Object.keys(socialSkillsData).map((cat) => (
          <React.Fragment key={cat}>
            <ListItem disablePadding>
              <ListItemButton
                selected={skillCategory === cat}
                onClick={() => setSkillCategory(skillCategory === cat ? '' : cat)}
              >
                <span style={{ fontWeight: 'bold' }}>{getCategoryName(cat, langKey)}</span>
                {skillCategory === cat ? <ExpandLess sx={{ marginLeft: 'auto' }} /> : <ExpandMore sx={{ marginLeft: 'auto' }} />}
              </ListItemButton>
            </ListItem>
            <Collapse in={skillCategory === cat} timeout="auto" unmountOnExit>
              {socialSkillsData[cat] && socialSkillsData[cat].length > 0 && (
                <List component="div" disablePadding>
                  {socialSkillsData[cat].map((skill) => (
                    <ListItem key={skill.key} disablePadding sx={{ pl: 4 }}>
                      <ListItemButton
                        selected={socialSkill && socialSkill.key === skill.key}
                        onClick={() => handleSkillSelect(skill)}
                        aria-label={`${selectionType}: ${
                          getSkillName
                            ? getSkillName(skill.key, cat, langKey)
                            : (skill[langKey] || skill.en)
                        }`}
                      >
                        {getSkillName
                          ? getSkillName(skill.key, cat, langKey)
                          : (skill[langKey] || skill.en)}
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              )}
            </Collapse>
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default SocialSkillPage;
